module.exports = __webpack_public_path__ + "static/media/VIA5.299974fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/VIA5.png
// module id = 563
// module chunks = 1